// pdf.js is loaded on demand so the Invoices list (and Jest) never pays for it.
let lib = null;

async function pdfjs() {
  if (!lib) {
    const mod = await import('pdfjs-dist/webpack');
    lib = mod.default || mod;
  }
  return lib;
}

export async function openPdf(arrayBuffer) {
  const p = await pdfjs();
  return p.getDocument({ data: new Uint8Array(arrayBuffer) }).promise;
}

/** Render one page into a canvas at `zoom` × fit-to-width. Returns a cancel function. */
export async function renderPage(pdf, pageNo, canvas, { width, zoom = 1, rotate = 0 }) {
  const page = await pdf.getPage(pageNo);
  const rotation = ((page.rotate || 0) + rotate) % 360;
  const base = page.getViewport({ scale: 1, rotation });
  const cssScale = ((width || base.width) / base.width) * zoom;
  const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
  const vp = page.getViewport({ scale: cssScale * dpr, rotation });
  canvas.width = Math.floor(vp.width);
  canvas.height = Math.floor(vp.height);
  canvas.style.width = `${Math.floor(vp.width / dpr)}px`;
  canvas.style.height = `${Math.floor(vp.height / dpr)}px`;
  const task = page.render({ canvasContext: canvas.getContext('2d'), viewport: vp });
  await task.promise;
  return () => task.cancel();
}
